interface BadgeProps {
  index: number;
}

const Badge = ({ index }: BadgeProps) => (
  <div className="w-6 h-6 rounded-full bg-navy-800 text-white text-xs font-bold flex items-center justify-center shadow">
    {index}
  </div>
);

export default Badge;
